import { Component } from '@angular/core';
import { Events, IonicPage, ModalController, NavController, NavParams } from 'ionic-angular';
import moment from 'moment';
import { AttendanceTempBloc } from '../../bloc/hr/attendance/attendance-temp.bloc';
import { AttendanceBloc } from '../../bloc/hr/attendance/attendance.bloc';
import { Messages } from '../../helpers/messages';
import { GDAuthInterface } from '../../model/gd-auth';
import { AppPreferences } from '../../shared/local/app-preferences.local';
import { NestResponsesProvider } from '../../shared/nestjs/nest-responses';

/**
 * Generated class for the AttendanceResultPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-attendance-result',
  templateUrl: 'attendance-result.html',
})
export class AttendanceResultPage {

  public isOffline: boolean = false;
  public SFGoAuth: GDAuthInterface;
  public attendanceList: any[] = [];
  public isSuccess: boolean = false;
  public isError: boolean = false;
  public errorMessage: any;
  public message: any;
  public offlineModeEnabled = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public attendanceTempBloc: AttendanceTempBloc,
    public nestResponses: NestResponsesProvider,
    public appPreferences: AppPreferences,
    public modalCtrl: ModalController,
    public events: Events,
    public attendanceBloc: AttendanceBloc
  ) {

  }

  async ionViewDidLoad() {
    this.eventListener();
    this.offlineModeEnabled = this.attendanceBloc.attendanceSetting.offlineMode
    console.log(this.attendanceBloc.attendanceSetting);
  }

  eventListener() {
    this.events.subscribe('attendance:success-record-attendance', async (data) => {
      this.isSuccess = true;
      this.isError = false;

      try {
        this.SFGoAuth = await this.appPreferences.getAuth();
        this.message = this.attendanceBloc.messageSuccessAttendance(this.SFGoAuth, data.response, data.record);
      } catch (error) {
        this.message = Messages.SUCCESS_SAVED_ATTENDANCE;
      }

      this.getNewTodayAttendance();
    });

    this.events.subscribe('attendance:failed-record-attendance', data => {
      console.log('error data', data)
      this.isError = true;
      this.isSuccess = false;
      this.errorMessage = data;
      this.message = this.offlineModeEnabled
        ? Messages.FAILED_SAVED_ATTENDANCE
        : Messages.FAILED_SAVED_ATTENDANCE_WITHOUT_OFFLINEMODE;
    });
  }

  async getNewTodayAttendance() {
    try {
      const params = {
        date: new Date().toISOString(),
        empId: this.SFGoAuth.empId
      }

      this.attendanceList = await this.attendanceTempBloc.getNewTodayAttendance(params);
    } catch (error) {
      // this.nestResponses.error(error);
    }
  }

  showLog(params: { data: any, flag: 'today' | 'yesterday', empId?: any, attendDate?: any }) {
    params.empId = this.SFGoAuth.empId;
    params.attendDate = params.flag == 'today' ? moment().toISOString() : moment().startOf('day').add(moment().utcOffset(), 'minutes').subtract(1, 'day').toISOString();
    let modal = this.modalCtrl.create("TimeAttendanceLogPage", { paramPage: params });
    modal.present();
  }


  gotoMap(geolocation, flag: string) {
    let data = {
      fullName: this.SFGoAuth.fullName,
      geo: geolocation,
      flagTime: flag
    }
    this.navCtrl.push('TimeAttendanceListMap', data);
  }

  toOfflineList() {
    this.navCtrl.push("OfflineModeListPage")
  }

  backHome() {
    this.navCtrl.popToRoot();
  }
}



// WEBPACK FOOTER //
// ./src/pages/attendance-result/attendance-result.ts